import React, { useRef } from 'react';
import USBRadioGroup from '@usb-shield/react-forms-radio-group';

function QuestionRadioGroup({
    id,
    metadata,
    answers,
    dynamicErrorCount,
    errorMessages,
    inputValue,
    updateCallback = () => {},
}) {
    const radioRef = useRef();

    const convertedAnswers = answers.map((thisAnswer) => ({
        label: thisAnswer.label,
        value: thisAnswer.id,
    }));
    const localInputVal =
        inputValue.length > 0 ? inputValue.toString() : '';
    return (
        <div>
            <USBRadioGroup
                ref={radioRef}
                inputName={id}
                legendText={metadata?.question}
                options={convertedAnswers}
                dynamicErrorCount={dynamicErrorCount}
                statusUpdateCallback={updateCallback}
                errorMessages={errorMessages}
                dynamicValue={localInputVal}
            />
        </div>
    );
}

export default QuestionRadioGroup;
